import type { NewCustomerWizardStep } from "./newCustomerWizardSteps";
import styles from "./NewCustomerStep1Page.module.css";

type WizardStepHeaderProgressProps = {
  wizardStep: NewCustomerWizardStep;
};

export function WizardStepHeaderProgress({
  wizardStep,
}: WizardStepHeaderProgressProps) {
  const { step, title, percent } = wizardStep;

  return (
    <div
      className={styles.progressCard}
      data-testid={`new-customer-step-${step}-progress`}
    >
      <h1
        className={styles.pageTitle}
        data-testid={`new-customer-step-${step}-title`}
      >
        Step {step} of 4 · {title}
      </h1>
      <div
        className={styles.progressTrack}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Form progress"
      >
        <div
          className={styles.progressFill}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span
        className={styles.progressPct}
        data-testid={`new-customer-step-${step}-indicator`}
      >
        {percent}%
      </span>
    </div>
  );
}
